/**
 * Returns whether two arrays have a common element.
 */
export const hasCommonElement = <T>(left?: T[] | null, right?: T[] | null): boolean =>
  left?.length && right?.length ? left.some(element => right.includes(element)) : false;
